import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotifyList from './List';
import NotifyCreate from './Create';
import NotifyDetail from './Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Summary: { visible: false, label: '', required: false },
    Location: { visible: false, label: '', required: false },
    Date: { visible: false, label: '', required: false },
    Time: { visible: false, label: '', required: false },
    Attendees: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Summary = { visible: true, label: languageFile["CONTRACT.WF.MEETING.FIELD.SUMMARY"], required: true };
    fields.Location = { visible: true, label: languageFile["CONTRACT.WF.MEETING.FIELD.LOCATION"], required: true };
    fields.Date = { visible: true, label: languageFile["CONTRACT.WF.MEETING.FIELD.DATE"], required: true };
    fields.Time = { visible: true, label: languageFile["CONTRACT.WF.MEETING.FIELD.TIME"], required: true };
    fields.Attendees = { visible: true, label: languageFile["CONTRACT.WF.MEETING.FIELD.ATTENDEES"], required: true };

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

class RecordRouter extends React.Component {
    constructor(props) {
        super(props);

        if (props.mode === 'PM') {
            this.notificationType = 'PMMeeting';
            this.documentType = 'DocumentPMMeeting';
        }
        else if (props.mode === 'SUPPLIER') {
            this.notificationType = 'ContractorMeeting';
            this.documentType = 'DocumentConMeeting';
        }

        this.notifyingParty = props.workflowItem.notifyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<NotifyList
                            {...this.props}
                            
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                        />}
                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <NotifyCreate
                                    {...this.props}
                                    
                                    title={this.notificationName}
                                    notificationType={this.notificationType}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<NotifyDetail
                            {...this.props}
                            
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                            documentType={this.documentType}
                            notifyUserFilter={workflowItem.notifyUserFilter}
                        />}
                    />
                </Routes>
            </>
        );
    }
}



export default (RecordRouter);